export interface GridPreferences {
  rowHeight: number;
}

export interface AppPreferences {
  grid: GridPreferences;
}

export const DEFAULT_GRID_ROW_HEIGHT = 25;

export const MIN_GRID_ROW_HEIGHT = 16;
export const MAX_GRID_ROW_HEIGHT = 200;

export function defaultPreferences(): AppPreferences {
  return { grid: { rowHeight: DEFAULT_GRID_ROW_HEIGHT } };
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

function sanitizeGrid(
  patch: Partial<GridPreferences>,
): Partial<GridPreferences> {
  const clean: Partial<GridPreferences> = {};
  const height = Number(patch.rowHeight);
  if (Number.isFinite(height)) {
    clean.rowHeight = Math.round(
      clamp(height, MIN_GRID_ROW_HEIGHT, MAX_GRID_ROW_HEIGHT),
    );
  }
  return clean;
}

export class Preferences {
  private readonly state: AppPreferences;

  constructor(initial?: Partial<AppPreferences>) {
    this.state = defaultPreferences();
    if (initial) {
      this.merge(initial);
    }
  }

  get values(): Readonly<AppPreferences> {
    return this.state;
  }

  get grid(): Readonly<GridPreferences> {
    return this.state.grid;
  }

  merge(patch: Partial<AppPreferences>): void {
    if (patch.grid) {
      Object.assign(this.state.grid, sanitizeGrid(patch.grid));
    }
  }

  reset(): void {
    Object.assign(this.state, defaultPreferences());
  }
}
